<template>
  <div>
    <q-dialog
      v-model="pagesUtilStore.showModalRequestAdjustmentsInstitucional"
      :no-backdrop-dismiss="true"
    >
      <q-card class="midia-app-padding-modal" style="width: 448px;">
        <div>
          <c-modal-title
            propModalTitle="Solicitar Ajuste"
            :propModalDescription="(
              (pagesUtilStore.modalRequestedAdjustmentsInstitucionalModalType == EnumRequestedAdjustmentsInstitucionalModalType.CREATE) ? 'Informe os ajustes necessários:' :
              (pagesUtilStore.modalRequestedAdjustmentsInstitucionalModalType == EnumRequestedAdjustmentsInstitucionalModalType.UPDATE) ? 'Verifique os Ajustes Solicitados' :
              ''
            )"
          />

          <!-- ✅ Comentário existente (readonly) -->
          <div v-if="institutionalStore.institutionalDetail?.comentarioAjuste" class="row fit no-wrap q-pb-lg">
            <div class="col-grow" style="overflow: auto;">
              <q-input
                style="position: relative;"
                v-model="institutionalStore.institutionalDetail.comentarioAjuste"
                type="textarea"
                maxlength="255"
                color="globalAppPrimaryColor"
                bg-color="globalAppDefaultBackgroundColor"
                outlined
                dense
                placeholder="Digite aqui..."
                input-class="midia-app-content-lg"
                :readonly="true"
              />
            </div>
          </div>

          <!-- ✅ Novo comentário -->
          <div class="row fit no-wrap q-pb-lg">
            <div class="col-grow" style="overflow: auto;">
              <q-input
                style="position: relative;"
                v-model="refRequestedAdjustments"
                type="textarea"
                maxlength="255"
                color="globalAppPrimaryColor"
                bg-color="globalAppDefaultBackgroundColor"
                outlined
                dense
                placeholder="Digite aqui..."
                input-class="midia-app-content-lg"
                :disable="disableEditAskAdjustmen"
              />
            </div>
          </div>

          <div class="row fit flex no-wrap justify-between q-pb-xs" style="width: 100%;">
            <div class="q-pr-sm">
              <c-q-btn
                id="btn-cancel"
                propBtnLabel="Cancelar"
                :propBtnTransparent="true"
                :propBtnSize="EnumButtonSizes.LARGE_1"
                v-close-popup
              />
            </div>

<div class="q-pl-sm">
  <c-q-btn
    v-if="showOkButton"
    id="btn-adjustment"
    propBtnLabel="OK"
    :propBtnTransparent="false"
    :propBtnSize="EnumButtonSizes.LARGE_1"
    :propBtnFunction="onOkBtnClick"
  />
</div>






            <div class="col col-grow q-pl-sm">
              <!-- ✅ Enviar ajuste -->
              <c-q-btn
                v-if="institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id"
                id="btn-send-requested-adjustments"
                style="width: 100%;"
                propBtnLabel="Enviar"
                :propBtnFunction="onSendRequestedAdjustmentsBtnClick"
                :propBtnTransparent="false"
                :propBtnSize="EnumButtonSizes.LARGE_1"
                :disable="!refRequestedAdjustments?.trim()"
              />

              <!-- ✅ Enviar reajuste -->
              <c-q-btn
                v-if="institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id"
                id="btn-send-requested-adjustments"
                style="width: 100%;"
                propBtnLabel="Enviar"
                :propBtnFunction="onSendRequestedAdjustmentsAgainBtnClick"
                :propBtnTransparent="false"
                :propBtnSize="EnumButtonSizes.LARGE_1"
                :disable="!refRequestedAdjustments?.trim()"
              />
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

import { EnumRequestedAdjustmentsInstitucionalModalType, EnumButtonSizes } from '@/enums/enums'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import messages from '@/utils/messages'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

// ✅ ref local — igual campaignStore.refRequestedAdjustments nas campanhas
const refRequestedAdjustments = ref('')

const institutionalInfo = computed(() => {
  return (
    institutionalStore.reviewData ||
    institutionalStore.institutionalDetail ||
    institutionalStore.institutionalDraft
  )
})

const showOkButton = computed(() => {
  const status = institutionalInfo.value?.status
  return (
    status !== CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id &&
    status !== CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id
  )
})

const onOkBtnClick = () => {
  if (refRequestedAdjustments.value.trim() && institutionalStore.institutionalDetail) {
    institutionalStore.institutionalDetail.comentarioAjuste = refRequestedAdjustments.value
    refRequestedAdjustments.value = ''
  }
  pagesUtilStore.showModalRequestAdjustmentsInstitucional = false
}





const disableEditAskAdjustmen = computed(() => {
  return (
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id ||
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id ||
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.PUBLISHED.id ||
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.APPROVED.id
  )
})

// ✅ Solicitar Ajuste — igual sendRequestedAdjustmentsFocusedCampaign
const onSendRequestedAdjustmentsBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.requestAdjustments(id, refRequestedAdjustments.value.trim())

    refRequestedAdjustments.value = ''
    messages.showSuccessMsg('Solicitação de ajustes realizada com sucesso!')
    pagesUtilStore.showModalRequestAdjustmentsInstitucional = false

  } catch (error: any) {
    messages.showErrorMsg(error.message)
  } finally {
    pagesUtilStore.showLoading = false
  }
}

// ✅ Solicitar Reajuste — igual sendRequestedAdjustmentsAgainFocusedCampaign
const onSendRequestedAdjustmentsAgainBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.requestReadjustments(id, refRequestedAdjustments.value.trim())

    refRequestedAdjustments.value = ''
    messages.showSuccessMsg('Solicitação de reajuste realizada com sucesso!')
    pagesUtilStore.showModalRequestAdjustmentsInstitucional = false

  } catch (error: any) {
    messages.showErrorMsg(error.message)
  } finally {
    pagesUtilStore.showLoading = false
  }
}
</script>

<style scoped></style>
